var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDifferencePlayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 10,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9091 16.9092H43.091V18.3637H44.5455V38.7274H43.091V40.1819H31.4546V41.6365H30V43.091H28.5455V44.5455H22.7273V40.1819H16.9091V38.7274H15.4546V18.3637H16.9091V16.9092ZM18.3637 19.8183V37.2728H25.6364V41.6365H27.091V40.1819H28.5455V38.7274H30V37.2728H41.6364V19.8183H18.3637ZM21.2728 24.1819H38.7273V27.091H21.2728V24.1819ZM21.2728 30.0001H35.8182V32.9092H21.2728V30.0001Z",
    fill: "#FFFF81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifferencePlayers);
export default __webpack_public_path__ + "static/media/difference_players.214d81c6056a768ae07df8d679c49bff.svg";
export { ForwardRef as ReactComponent };